import { z } from 'zod';

export const errorBeanSchema = z.object({
  message: z.string().nullish(),
});
